import { searchResultService } from '@/services';
import { SearchResultReq, DocSearchResultReq, CatergorySearchReq, SearchRetestReq } from '@/types/search-result';
import { useMutation, useQuery } from '@tanstack/react-query';

export const useQuerySearchResult = (searchResultReq: SearchResultReq) => {
  return useQuery({
    queryKey: ['SEARCH_RESULT', searchResultReq],
    queryFn: async () => {
      const res = await searchResultService.getSearchResult(searchResultReq);
      return res.data;
    },
    enabled: !!searchResultReq.countryCode,
    staleTime: 0,
    cacheTime: 0,
  });
};

export const useQueryCatalogNotes = (catalogNumbers: string[] = [], enabled = true) => {
  return useQuery({
    queryKey: ['CATALOG_NOTES', catalogNumbers],
    queryFn: async () => {
      const res = await searchResultService.getCatalogNotes(catalogNumbers);
      return res.data;
    },
    enabled: enabled && catalogNumbers?.length > 0,
  });
};

export const useQueryDocSearchResult = (searchResultReq: DocSearchResultReq) => {
  const { page, pageSize, documentType, catalogNumber, resetPage } = searchResultReq;
  return useQuery({
    queryKey: ['DOC_SEARCH_RESULT', page, pageSize, documentType, catalogNumber],
    queryFn: async () => {
      const res = await searchResultService.getDocSearchResult(searchResultReq);
      return res;
    },
    enabled: catalogNumber !== undefined && !resetPage,
    keepPreviousData: true,
  });
};
export const useQueryCategorySearchResult = (searchResultReq: CatergorySearchReq) => {
  return useQuery({
    queryKey: ['CAT_SEARCH_RESULT', searchResultReq],
    queryFn: async () => {
      const res = await searchResultService.getCategorySearch(searchResultReq);
      return res;
    },
    staleTime: 0,
    cacheTime: 0,
    enabled: !!searchResultReq.countryCode,
  });
};

export const useQueryChildCatalogs = (catalogNumber: string, enabled = true) => {
  return useQuery({
    queryKey: ['QUERY_CHILD_CATALOGS', catalogNumber],
    queryFn: async () => {
      const res = await searchResultService.getChildCatalogs(catalogNumber);
      return res.filter((item) => item.skuStatus === 'RELEASED') || [];
    },
    enabled: !!catalogNumber && enabled,
  });
};

export const useQueryCatalogInfo = () => {
  return useMutation({
    mutationFn: (catalogNumbers: string[]) => searchResultService.getCatalogInfo(catalogNumbers),
  });
};
export const useMutationSearchResult = () => {
  return useMutation({
    mutationFn: (searchResultReq: SearchRetestReq) => searchResultService.getRetestSearchResult(searchResultReq),
  });
};
